import styled from 'styled-components';
import useOptionInventory from '../User/Live/useOptionInventory';

// First-pass G1 presentation is limited to the isolated web-sender review.
export function isWebInventoryReview() {
  return document.documentElement.dataset.reviewRole === 'web' && Boolean(document.querySelector('meta[name="fanbird-local-review"]'));
}

export default function ReviewOptionInventory({ productSeq }: { productSeq?: number }) {
  const inventory = useOptionInventory(productSeq, Boolean(productSeq), undefined, undefined, true);
  return <Options aria-label="옵션별 남은 수량">
    {inventory.loading && <p role="status">옵션 수량 확인 중</p>}
    {inventory.error ? <p role="alert">옵션 수량을 확인하지 못했습니다. <button type="button" onClick={inventory.retry}>다시 시도</button></p>
      : <ul>{inventory.options.map(row => <li key={row.seq}><span>{[row.option1,row.option2].filter(Boolean).join(' / ')}</span><strong>{row.current_cnt}개</strong></li>)}</ul>}
  </Options>;
}
const Options = styled.div`
  grid-column: 1 / -1; max-height: 136px; overflow-y: auto;
  padding: var(--space-2) var(--space-3); border-top: 1px solid var(--color-border-default);
  color: var(--admin-theme-text, var(--color-text-primary)); font-size: var(--text-caption); line-height: var(--leading-caption);
  ul, p { margin: 0; padding: 0; list-style: none; }
  li { display: flex; justify-content: space-between; gap: var(--space-3); padding: var(--space-1) 0; }
  span { min-width: 0; overflow-wrap: anywhere; }
  strong { flex-shrink: 0; font-variant-numeric: tabular-nums; }
  button { min-height: 44px; padding: var(--space-2); border: 1px solid var(--color-border-default); border-radius: var(--radius-md); background: var(--color-bg-surface); color: inherit; cursor: pointer; }
`;
